import { Link } from "react-router-dom";
import { PageHero } from "../components/PageShell";
import { Placeholder } from "../components/Placeholder";
import { ROUTES } from "../lib/routes";
import { INDUSTRY_PARTNERS } from "../lib/industryPartners";

const stats = [
  { num: "31", lbl: "Active MoUs" },
  { num: "9", lbl: "Sectors" },
  { num: "640", lbl: "Internships placed · 5 yrs" },
  { num: "48", lbl: "Sponsored projects · 5 yrs" },
];

const modes = [
  { name: "Sponsored labs & Centres of Excellence", desc: "Partners equip and co-run laboratories on campus — from Bosch's embedded-systems lab to the Siemens automation CoE — giving students current industry tooling." },
  { name: "Internships & placements", desc: "Structured intern-to-hire pipelines and dedicated recruitment drives across IT, core engineering and manufacturing partners." },
  { name: "Live projects & capstones", desc: "Industry-defined problem statements anchor final-year projects, co-mentored by company engineers and BIET faculty." },
  { name: "Guest lectures & faculty enablement", desc: "Train-the-trainer programs, certification tracks and a regular guest-lecture series keep curriculum aligned with practice." },
];

export default function International() {
  return (
    <>
      <PageHero
        variant="hero-photo"
        eyebrow="Industry Relations Cell"
        title="Industry Collaborations & MoUs across nine sectors."
        lead="BIET maintains active memoranda of understanding with leading companies and industry bodies — IT services, automotive, defence electronics, manufacturing, infrastructure and power. These tie-ups bring sponsored labs, live projects, internships and recruitment directly to our students and departments."
        crumbs={[{ label: "Research", to: ROUTES.research }, { label: "Industry Collaborations & MoUs" }]}
        image={null}
      />
      <section className="section">
        <div className="container">
          <div className="kicker">At a glance</div>
          <div className="stat-row">
            {stats.map((s, i) => (
              <div key={i} className="cell"><div className="num">{s.num}</div><div className="lbl">{s.lbl}</div></div>
            ))}
          </div>

          <h2 style={{ marginTop: 80, fontSize: "clamp(28px, 3vw, 40px)", fontWeight: 600 }}>Industry partners</h2>
          <p style={{ color: "var(--text-soft)", marginTop: 8, fontSize: 17, maxWidth: "60ch" }}>A representative selection of our partner companies and industry bodies. Department-specific tie-ups are also listed on each department page.</p>
          <div className="partner-grid">
            {INDUSTRY_PARTNERS.map((p) => (
              <Link key={p.slug} to={`${ROUTES.intlPartners}/${p.slug}`} className="partner-card reveal">
                <span className="flag">{p.tag}</span>
                <div className="country">{p.sector}</div>
                <div className="pname">{p.name}</div>
                <p className="desc">{p.desc}</p>
                <div className="since">{p.since}</div>
              </Link>
            ))}
          </div>

          <h2 style={{ marginTop: 80, fontSize: "clamp(28px, 3vw, 40px)", fontWeight: 600 }}>Modes of collaboration</h2>
          <div className="resource-list">
            {modes.map((m, i) => (
              <div key={i} className="item reveal" style={{ cursor: "default" }}>
                <span className="pub">MODE</span>
                <span className="name">{m.name}</span>
                <span className="meta">{m.desc}</span>
              </div>
            ))}
          </div>

          <div className="two-col" style={{ marginTop: 80 }}>
            <div className="reveal">
              <div className="kicker">For companies</div>
              <h3>Considering a collaboration?</h3>
              <p>The Industry Relations Cell welcomes proposals for sponsored labs, Centres of Excellence, joint projects, internships and recruitment partnerships. Initial conversations are confidential and non-binding; an MoU is signed only after scope is agreed by both sides.</p>
              <p style={{ marginTop: 16 }}><b>Typical timeline</b>: 3 weeks for scope alignment, 2 weeks for internal approvals, 1 week for signing.</p>
              <p style={{ marginTop: 16 }}>Contact: <a href="mailto:industry@bietdvg.edu" style={{color:"var(--accent-strong)", textDecoration:"underline"}}>industry@bietdvg.edu</a> &middot; Dr. Faculty-15, Dean (Industry Relations).</p>
            </div>
            <div className="reveal">
              <Placeholder label="MoU SIGNING · CEREMONY" aspect="4/5" />
            </div>
          </div>

          <div className="contact-grid" style={{ marginTop: 80 }}>
            <div className="contact-block">
              <div className="ctype">Cell</div>
              <h3>Industry Relations Cell</h3>
              <dl className="row"><dt>Dean</dt><dd>Dr. Faculty-15</dd><dt>Phone</dt><dd>+91 8192 233 890</dd><dt>Email</dt><dd><a href="mailto:industry@bietdvg.edu">industry@bietdvg.edu</a></dd></dl>
            </div>
            <div className="contact-block">
              <div className="ctype">Placements</div>
              <h3>Training &amp; Placement</h3>
              <dl className="row"><dt>Officer</dt><dd>Prof. Faculty-29</dd><dt>Email</dt><dd><a href="mailto:placement@bietdvg.edu">placement@bietdvg.edu</a></dd><dt>Walk-in</dt><dd>Mon &amp; Thu · 14:00–17:00</dd></dl>
            </div>
            <div className="contact-block">
              <div className="ctype">MoUs</div>
              <h3>MoU &amp; partnerships desk</h3>
              <dl className="row"><dt>Email</dt><dd><a href="mailto:mou@bietdvg.edu">mou@bietdvg.edu</a></dd><dt>Scope</dt><dd>Drafting &amp; renewals</dd></dl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
